<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="productDispatchForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                productDispatchForm: () => import('../forms/ProductDispatchForm'),
                headers: [
                    { text: 'Product', value: 'productId', table: 'products', form: () => import('../forms/ProductForm') },
                    { text: 'Batch Number', value: 'batchNumber' },
                    { text: 'Price', value: 'price' },
                    { text: 'Client Name', value: 'clientName' },
                    { text: 'Packed On', value: 'packedOn', format: this.formatDate },
                    { text: 'Dispatched On', value: 'dispatchedOn', format: this.formatDate },
                    { text: 'Expires On', value: 'expiresOn', format: this.formatDate },
                    { text: 'Pack Format', value: 'packFormat' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    products: [],
                    items: []
                },
                sorting: [
                    { column: "packedOn", direction: "descending" },
                    { column: "batchNumber", direction: "ascending" },
                    { column: "productId", direction: "ascending" },
                ],
                itemsField: 'productDispatches',
                editPageName: 'productDispatch',
                apiMethod: 'ProductDispatches',
                claimName: 'ProductDispatches',
                formTitle: 'Product Dispatch',
                excelTitle: 'Product Dispatches',
                hasEditPage: false,
            }
        },
    };
</script>
